module.exports = __webpack_public_path__ + "b410817dd36d22a69aa26e99558bc9b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2088_teaser_image.jpg
// module id = 591
// module chunks = 0